module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Pfalz-cab2184fce68d0f1a4be2e993f43904d.jpeg";